import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import IntroLoader from "./IntroLoader";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import RouteManager from "./RouteManager";
import { ProviderDialog, GalleryDialog } from "./Dialogs";
import { useSite } from "../hooks/useSite";
import "../styles/site.css";
import "../styles/pages.css";

export default function SiteShell({ children }) {
  const { theme } = useSite();
  const location = useLocation();
  // The opening sequence runs once per full page load, and only when that
  // load lands on the homepage. Later in-app navigation (including the
  // header logo) never replays it.
  const [intro, setIntro] = useState(() => location.pathname === "/");
  // If the intro is not going to run (non-home load), drop any boot cover.
  if (!intro && typeof document !== "undefined") {
    const boot = document.getElementById("ro-boot");
    if (boot) boot.remove();
  }
  return (
    <div className="ro-site" style={{ "--ro-theme": theme.colour, "--ro-pale": theme.pale }}>
      {intro && <IntroLoader onDone={() => setIntro(false)} />}
      <a href="#ro-main" className="ro-skip">
        Skip to content
      </a>
      <RouteManager />
      <SiteHeader />
      <main id="ro-main" tabIndex={-1} className="ro-main" aria-busy={intro || undefined}>
        {children}
      </main>
      <SiteFooter />
      <ProviderDialog />
      <GalleryDialog />
    </div>
  );
}
